import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { MethodApi } from '../../api/api-request';
import { Event } from '@co-assist/library';
@Injectable({
    providedIn: 'root'
})
export class StockService {
    constructor(
        private api: MethodApi
    ) { }

    getStockItems(event: Event.Administration.GetStockItemsEvent): Observable<Event.Administration.GetStockItemsResponse> {
        return this.api.postAdministrationRequest('getStockItems', event);
    }
}
